import { Box, Grid, Typography, Button } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import LanguageIcon from '@mui/icons-material/Language';
import './VisitOurWebsite.styles.css';

const VisitOurWebsite = () => {
  return (
    <Grid container direction="row" columnSpacing={4} className="GridRow LightSkyBlue">
      <Grid size={{ xs: 12 }}>
        <Typography variant="h3" className="TextCenter">
          WANT TO SEE MORE? VISIT OUR WEBSITE
        </Typography>
        <Typography variant="body1" className="TextParaSecond">
          Get your tile, stone, and floor covering installations as fast, easy and durable as
          possible through performance-driven installation systems and support. At CBP, our expert
          customer support team will ensure you select the right tile installation materials for
          your job.
        </Typography>
        <Box sx={{ mt: 4 }} className="TextCenter">
          <a
            href="https://www.custombuildingproducts.com/grout-color-selector"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button
              variant="contained"
              color="primary"
              startIcon={<LanguageIcon />}
              endIcon={<OpenInNewIcon />}
            >
              Visit Custom Building Products
            </Button>
          </a>
        </Box>
      </Grid>
    </Grid>
  );
};

export default VisitOurWebsite;
